import React, { useState, useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';
import styles from './Timeline.module.css';
import Button from '../button/Button';
import learn from "../../icons/wired-outline-406-study-graduation-hover-pinch (3).json"
import faith from "../../icons/wired-outline-633-female-standing-morph-success.json"
import again from "../../icons/wired-outline-1594-manicure-hover-pinch (1).json"
import keep from "../../icons/wired-outline-1596-nails-hover-pinch (4).json"
export default function ScrollTimeline() {
  const [progress, setProgress] = useState(0);
  const timelineRef = useRef(null);
  const playerRefs = useRef([]);

  const items = [
    {
      icon:keep  ,
      title: "נחישות והתמדה",
      description:
        "נחישות היא מה שמבדיל בין תחביב למקצוע. התמדה מייצרת ביטחון, דיוק ויציבות בעבודה - והיא זו שבונה את השם שלך לאורך זמן! ככל שתתמידי יותר זמן הסיכויים שלך להצליח בתחום עולים וככל שתרצי להצליח ותפתעלי כדי לגרום לזה לקרות, הדברים יתחילו לזוז",
    },
    {
      icon: again,
      title: "תרגול ודיוק",
      description:
        "תרגול יומיומי הופך כל תנועה לטבעית וכל עבודה למושלמת. התרגול עוזר לי להיות מדוייקת יותר מפעם לפעם, לקצר את זמני העבודה שלך ולהפוך למומחית בתחום. ככל שתהי יותר מדוייקת יותר נשים יבואו אלייך וישלמו לך יותר!",
    },
    {
      icon: faith,
      title: "אמונה בעצמך",
      description:
        "אמונה עצמית היא הבסיס לכל הצלחה. כשאת מאמינה במה שאת עושה, כשאת מאמינה שאת תצליחי למרות מה שאחרים יכולים לומר בדרך, זה בונה בטחון עצמי של ווינרית ויותר סיכוי להצליח ולא לוותר בדרך!",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!timelineRef.current) return;

      const element = timelineRef.current;
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const elementTop = rect.top;
      const elementHeight = rect.height;

      const startPoint = windowHeight * 0.7;
      const endPoint = windowHeight * 0.3;

      if (elementTop > startPoint) {
        setProgress(0);
      } else if (elementTop + elementHeight < endPoint) {
        setProgress(100);
      } else {
        const scrolled = startPoint - elementTop;
        const total = elementHeight + (startPoint - endPoint);
        const percentage = (scrolled / total) * 100;
        setProgress(Math.min(Math.max(percentage, 0), 100));
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleComplete = (index) => {
    setTimeout(() => {
      playerRefs.current[index]?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    playerRefs.current.forEach((ref) => {
      ref?.playFromBeginning();
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div ref={timelineRef} className={styles.timeline}>
          <div className={styles.lineBackground} />
          <div className={styles.lineProgress} style={{ height: `${progress}%` }} />

          <div className={styles.itemsContainer}>
            {items.map((item, index) => {
              const itemProgress = Math.min(Math.max((progress - index * 25) * 4, 0), 100);
              const isActive = itemProgress > 0;

              return (
                <div key={index} className={styles.item}>
                  <div className={`${styles.circle} ${isActive ? styles.circleActive : ''}`}>
                    <div className={styles.iconWrapper}>
                      <Player
                        icon={item.icon}
                        ref={(el) => (playerRefs.current[index] = el)}
                        size="100%"
                        colorize="black"
                        onComplete={() => handleComplete(index)}
                      />
                    </div>
                    {isActive && itemProgress > 50 && <div className={styles.pulse} />}
                  </div>

                  <div
                    className={`${styles.content} ${isActive ? styles.contentActive : ''}`}
                    style={{
                      transform: `translateX(${isActive ? 0 : 40}px)`,
                      opacity: isActive ? 1 : 0.25,
                    }}
                  >
                    <h3 className={styles.title}>{item.title}</h3>
                    <p className={styles.description}>{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Button text="יש לי את זה, בואי נתחיל" />
    </div>
  );
}
